import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// FAQ Data
const helpData = {
  IMPS: [
    {
      question: "What is IMPS?",
      answer:
        "Immediate Payment Service (IMPS) is an instant real time electronic fund transfer service to transfer money from wallet a/c to bank account.",
    },
    {
      question: "How much time does it take to transfer money to the bank?",
      answer: "It's instant.",
    },
    {
      question: "What are the charges for IMPS Transfer?",
      answer: `Charges for IMPS transfer:\n\nAmount               Charges (Inclusive of GST)\nUp to Rs.1,000       Rs.10.00\nRs.5,001 and above   0.85% of Transfer Amount + GST`,
    },
    {
      question:
        "Does (Small PPI) Low KYC wallet a/c holder allowed to do the IMPS transactions?",
      answer:
        "No. Only Full KYC wallet a/c holders can do the IMPS transactions, but not (Small PPI) Low KYC wallet a/c holder.",
    },
    {
      question: "Is it mandatory to add beneficiary a/c before doing IMPS?",
      answer:
        "Yes, it is mandatory to add beneficiary bank a/c before doing IMPS.\nFor unregistered users we have provided Quick transfer. (under development)",
    },
    {
      question:
        "Is there any restriction on number of beneficiary accounts that are allowed for IMPS?",
      answer: "No, there is no restriction to add beneficiary for IMPS.",
    },
    {
      question:
        "Is there any restriction on number of Fund Transfer transactions (to bank a/c and other TA Wallet a/c)?",
      answer:
        "No restrictions on transactions allowed per day, subject to fund transfer limits.\nThis is applicable for fund transfer to bank a/c and other TA Wallet a/c.",
    },
    {
      question: "What is MMID?",
      answer: `• Mobile Money IDentifier (MMID) is a seven digit unique number issued by the bank upon registration of mobile number\n\n• MMID in combination with mobile number associated with it can be used for IMPS fund transfer instead of Bank a/c and IFSC code combination.`,
    },
    {
      question: "How can I use IMPS?",
      answer: `• Use “Fund Transfer” on the home page in the mobile app. If it is web application, use “Services” -> “Fund Transfer” menu\n\n• Select IMPS\n• Select “Using IFSC” option\n• Select the beneficiary bank a/c\n• Enter the amount\n• Click on send money\n• Money will be transferred to the selected beneficiary account`,
    },
    {
      question:
        "How can I do IMPS transfer using mobile number instead of bank a/c number?",
      answer: `• Use “Fund Transfer” on the home page in the mobile app. If it is web application, use “Services” -> “Fund Transfer” menu\n\n• Select IMPS\n• Select “Using MMID” option\n• Select the beneficiary MMID\n• Enter the amount\n• Click on send money\n• Money will be transferred to the selected beneficiary account`,
    },
    {
      question: "How much can I transfer using IMPS?",
      answer:
        "Maximum of Rs. 10,000/- can be transferred using IMPS at once in TA Wallet.",
    },
  ],
};

const IMPS = ({ selectedSection = "IMPS" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) =>
    setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <Box width="100%">
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 220, md: 260 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 1, sm: 3 },
        }}
      >
        <Box
          component="img"
          src="/Assets/IMPS.jpg"
          alt="IMPS banner"
          sx={{
            width: "100%",
            maxWidth: 1000,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 10px 10px",
          }}
        />
      </Box>

      {/* Heading */}
      <Box mt={3} display="flex" justifyContent="center">
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          IMPS
        </Typography>
      </Box>

      {/* FAQ List */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 900,
          mx: "auto",
          px: { xs: 1.5, sm: 2, md: 3 },
          mt: 2,
          py: 2,
        }}
      >
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  borderBottom: "1px solid #eee",
                  px: 2,
                  py: 1.5,
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText primary={item.question} />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
                  >
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default IMPS;
